/* 
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
*/
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { DataGrid } from "@mui/x-data-grid";
import br from "date-fns/locale/pt-BR";

export default function AcompanhamentoCargaGridCarregamentosCIFModalDetalhe(
  props: AcompanhamentoCargaGridCarregamentosCIFModalDetalhePropsTypes
) {
  
  const handleRowEditCommit = (params: any) => {
    let rowsArr = [...props.data];
    rowsArr.forEach((row: any) => {
      if (row.id == params.id) {
        console.log(params.value);
        row[params.field] = params.value;
      }
    });
    props.setRows(rowsArr);
  }
  
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterlocale={br}>
        <div className="divFlow">
          <div style={{ height: "50vh", width: "100%" }}>
            <DataGrid
              rows={props.data}
              columns={props.columns}
              rowsPerPageOptions={[50, 100, 250, 500]}
              onCellEditCommit={handleRowEditCommit}
            />
          </div>
        </div>
      </LocalizationProvider>
    </>
  );
}

interface AcompanhamentoCargaGridCarregamentosCIFModalDetalhePropsTypes {
  handleClose: any;
  data: any;
  setRows: any;
  columns: any;
}
